import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./DatePickerComponent.css"; // Importa tus estilos personalizados aquí

export class DatePickerComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: this.normalizeDateValue(this.props.value),
      includeTime: false,
    };
  }

  normalizeDateValue = (value) => {
    if (!value) {
      return null;
    }

    if (value instanceof Date) {
      if (isNaN(value.getTime())) {
        return null;
      }
      return new Date(
        value.getFullYear(),
        value.getMonth(),
        value.getDate(),
        12,
        0,
        0,
        0
      );
    }

    const txt = String(value).replace("[UTC]", "").trim();
    const dateOnlyMatch = txt.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnlyMatch) {
      const [, year, month, day] = dateOnlyMatch;
      return new Date(Number(year), Number(month) - 1, Number(day), 12, 0, 0, 0);
    }

    const parsed = new Date(txt);
    if (isNaN(parsed.getTime())) {
      return null;
    }

    return new Date(
      parsed.getFullYear(),
      parsed.getMonth(),
      parsed.getDate(),
      12,
      0,
      0,
      0
    );
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({ startDate: this.normalizeDateValue(this.props.value) });
    }
  }

  handleDateChange = (date) => {
    const normalizedDate = this.normalizeDateValue(date);
    const event = {
      target: {
        id: this.props.id,
        value: normalizedDate,
      },
    };
    this.setState({
      startDate: normalizedDate,
    });
    this.props.onChange(event);
  };

  handleIncludeTimeChange = (event) => {
    this.setState({
      includeTime: event.target.checked,
    });
  };

  render() {
    return (
      <div
        className={`date-picker-container ${this.props.className}`}
        style={{ width: "100%" }}
      >
        {this.props.label && (
          <label htmlFor={this.props.id} className="date-picker-label">
            {this.props.label}
          </label>
        )}
        {this.props.includeTimeOption && (
          <Form.Group controlId="includeTime" className="mb-2">
            <Form.Check
              type="checkbox"
              label="Incluir hora"
              checked={this.state.includeTime}
              onChange={this.handleIncludeTimeChange}
            />
          </Form.Group>
        )}
        <DatePicker
          id={this.props.id}
          selected={this.state.startDate}
          onChange={this.handleDateChange}
          showTimeSelect={this.state.includeTime}
          timeFormat="HH:mm"
          timeIntervals={15}
          timeCaption="Hora"
          dateFormat={
            this.state.includeTime ? "MMMM d, yyyy h:mm aa" : "MMMM d, yyyy"
          }
          className={"form-control"}
          wrapperClassName="w-100"
        />
      </div>
    );
  }
}
